// src/features/eVisitingCard/VisitingCard.slice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchGroupsThunk,
  fetchAllCardsThunk,
  fetchTemplatesByGroupThunk,
  sendCustomizationRequestThunk, 
    fetchMyCustomRequestsThunk ,
    fetchLanguagesThunk,
  fetchLanguageDetailsThunk,
} from "./VisitingCard.thunk";

const initialState = {
  groups: [],
   cardData: [],
  groupTemplates: [],
    languages: [],
  languageDetail: null,
  customRequest: null,
  customRequests: [],
  professionalTemplate: null,
  todaySpecialTemplate: null,
  businessCardGroups: [],
  loading: false,
  error: null,
};

const eVisitingCardSlice = createSlice({
  name: "eCard",
  initialState,
  reducers: {},
 extraReducers: (builder) => {
  builder

    // ---------------- GROUPS ----------------
    .addCase(fetchGroupsThunk.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchGroupsThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.groups = action.payload;
    })
    .addCase(fetchGroupsThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // ---------------- ALL CARDS ----------------
    .addCase(fetchAllCardsThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(fetchAllCardsThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.cardData = action.payload;
      const professionalCard = action.payload.find(
        (c) => c.name === "Professional Card"
      );
      state.professionalTemplate = professionalCard?.template || null;
      const todaySpecialCard = action.payload.find(
        (c) => c.name === "Today Special Card"
      );
      state.todaySpecialTemplate = todaySpecialCard?.template || null;
      const businessCard = action.payload.find(
        (c) => c.name === "Business Card"
      );
      state.businessCardGroups = businessCard?.groups || [];
    })
    .addCase(fetchAllCardsThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // ---------------- GROUP TEMPLATES ----------------
    .addCase(fetchTemplatesByGroupThunk.fulfilled, (state, action) => {
      state.groupTemplates = action.payload;
    })

    // ---------------- SEND CUSTOMIZATION REQUEST ----------------
    .addCase(sendCustomizationRequestThunk.fulfilled, (state, action) => {
      state.customRequest = action.payload;
    })

    // ---------------- GET MY CUSTOMIZED REQUESTS ----------------
   // ---------------- GET MY CUSTOMIZED REQUESTS ----------------
.addCase(fetchMyCustomRequestsThunk.pending, (state) => {
  state.loading = true;
})
.addCase(fetchMyCustomRequestsThunk.fulfilled, (state, action) => {
  state.loading = false;
  state.customRequests = Array.isArray(action.payload)
    ? action.payload
    : action.payload?.data || [];
})
.addCase(fetchMyCustomRequestsThunk.rejected, (state, action) => {
  state.loading = false;
  state.error = action.payload;
})

    // ---------------- CARD LANGUAGES ----------------
    .addCase(fetchLanguagesThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(fetchLanguagesThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.languages = action.payload;
    })
    .addCase(fetchLanguagesThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    })

    // ---------------- LANGUAGE DETAILS ----------------
    .addCase(fetchLanguageDetailsThunk.pending, (state) => {
      state.loading = true;
    })
    .addCase(fetchLanguageDetailsThunk.fulfilled, (state, action) => {
      state.loading = false;
      state.languageDetail = action.payload;
    })
    .addCase(fetchLanguageDetailsThunk.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
},
});

export default eVisitingCardSlice.reducer;
